module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }